import { useTaskSummaries } from "@api/task.api";
import { Task } from "@common/types/task";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTasksContext } from "../../tasks.context";

export function useTaskBlockingSection(task: Task) {
    const { goToTask: goToOpenTask } = useTasksContext();
    const [addOpen, setAddOpen] = useState(false);
    const {
        data: taskSummaries = [],
        refetch,
        isFetching,
        isSuccess,
    } = useTaskSummaries();
    const hasRequestedInitialRefetch = useRef(false);

    useEffect(() => {
        if (hasRequestedInitialRefetch.current || isFetching || isSuccess) {
            return;
        }
        hasRequestedInitialRefetch.current = true;
        refetch();
    }, [isFetching, isSuccess, refetch]);

    const goToTask = useCallback(
        (taskId: string) =>
            goToOpenTask({ taskId, workspaceId: task.workspaceId }),
        [goToOpenTask, task.workspaceId],
    );

    return {
        taskSummaries,
        goToTask,
        addOpen,
        setAddOpen,
    };
}
